
// 创建loading方法，在需要时发起调用

//计数器
let needLoadingRequestCount = 0
//将多个请求合并，
export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}
// startLoading()和endLoading()就是调用 element 的 loading 方法。

import { Loading } from 'element-ui'

let loading

function startLoading() {
  loading = Loading.service({
    lock: true,
    spinner:'',
    text: '',
   background: 'rgba(0, 0, 0, 0.8)'
  })
}

function endLoading() {
  loading.close()
}
